import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

/**
 * Sticky mobile CTA — appears on small screens after a short scroll and
 * stays anchored at the bottom. Scrolls to the inline enquiry form (#enquiry).
 * Hidden on /admin and once the enquiry form is in view.
 */
export default function StickyMobileCTA() {
  const { pathname } = useLocation();
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    const onScroll = () => {
      const past = window.scrollY > 480;
      // Hide if the enquiry form is visible so we don't double-CTA.
      const enq = document.getElementById("enquiry");
      let nearForm = false;
      if (enq) {
        const r = enq.getBoundingClientRect();
        nearForm = r.top < window.innerHeight && r.bottom > 0;
      }
      setShow(past && !nearForm);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [pathname]);

  if (pathname.startsWith("/admin")) return null;

  return (
    <div
      data-testid="sticky-mobile-cta"
      className={`lg:hidden fixed bottom-3 inset-x-3 z-40 transition-all duration-500 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"
      }`}
    >
      <div className="glass-strong rounded-full pl-4 pr-2 py-2 flex items-center justify-between gap-3 shadow-[0_24px_60px_-20px_rgba(199,166,106,0.40)]">
        <div className="leading-tight">
          <div className="text-[11px] uppercase tracking-[0.16em] text-gold">Quietly considered</div>
          <div className="text-[13px] text-mute-100">Start a conversation</div>
        </div>
        <Link
          to="/#enquiry"
          data-testid="sticky-mobile-cta-link"
          className="btn-primary py-2 px-4 text-[12.5px]"
        >
          Begin
          <ArrowUpRight className="w-3.5 h-3.5" />
        </Link>
      </div>
    </div>
  );
}
